// extracted by mini-css-extract-plugin
export default {"bottom":"Bottom_bottom__Pjrp1","icon":"Bottom_icon__-34Mw","face":"Bottom_face__Fn5nr"};